module.exports = __webpack_public_path__ + "img/insights.dce174b6.svg";